import React, { useState } from 'react';
import './Sidebar.css';

const Sidebar = ({ enabledGames, onGameSelect, customItems = [], onCustomItemsClick, userSettings, hotlistItems = [], onHotlistClick, additionalCategories = [], onAdditionalCategorySelect }) => {
  const [activeGame, setActiveGame] = useState(null);
  const [customItemsActive, setCustomItemsActive] = useState(false);
  const [hotlistActive, setHotlistActive] = useState(false);
  const [activeAdditionalCategory, setActiveAdditionalCategory] = useState(null);

  const handleGameClick = (game) => {
    setActiveGame(game);
    setCustomItemsActive(false);
    setHotlistActive(false);
    setActiveAdditionalCategory(null);
    onGameSelect(game);
  };

  const handleCustomItemsClick = () => {
    setActiveGame(null);
    setCustomItemsActive(true);
    setHotlistActive(false);
    setActiveAdditionalCategory(null);
    if (onCustomItemsClick) {
      onCustomItemsClick();
    }
  };

  const handleHotlistClick = () => {
    setActiveGame(null);
    setCustomItemsActive(false);
    setHotlistActive(true);
    setActiveAdditionalCategory(null);
    if (onHotlistClick) {
      onHotlistClick();
    }
  };

  const handleAdditionalCategoryClick = (category) => {
    setActiveGame(null);
    setCustomItemsActive(false);
    setHotlistActive(false);
    setActiveAdditionalCategory(category.product_type);
    if (onAdditionalCategorySelect) {
      onAdditionalCategorySelect(category);
    }
  };

  return (
    <div className="alt-sidebar-dark">
      <div className="alt-sidebar-games-dark">
        <h3>We Buy</h3>
        <ul className="alt-game-list-dark">
          {enabledGames.map((game, index) => (
            <li 
              key={index} 
              className={`alt-game-item-dark ${activeGame === game ? 'active' : ''}`}
              onClick={() => handleGameClick(game)}
            >
              {game === 'Star Wars Unlimited' ? (
                <>
                  <span className="alt-star-icon-dark">★</span>
                  <span>{game}</span>
                </>
              ) : (
                <span>{game}</span>
              )}
            </li>
          ))}
          
          {/* Additional buylist categories (e.g., Sealed Pokemon) */}
          {additionalCategories.map((category, index) => (
            <li
              key={`additional-${index}`}
              className={`alt-game-item-dark alt-additional-category-dark ${activeAdditionalCategory === category.product_type ? 'active' : ''}`}
              onClick={() => handleAdditionalCategoryClick(category)}
            >
              <span>{category.product_type}</span>
            </li>
          ))}

          {/* Hotlist button - only show if we have hotlist items */}
          {hotlistItems.length > 0 && (
            <li
              className={`alt-game-item-dark alt-hotlist-item-dark ${hotlistActive ? 'active' : ''}`}
              onClick={handleHotlistClick}
            >
              <span className="alt-flame-icon-dark">🔥</span>
              <span>Hotlist</span>
            </li>
          )}

          {/* Other Items We Buy button - only show if we have custom items */}
          {customItems.length > 0 && (
            <li
              className={`alt-game-item-dark alt-custom-items-dark ${customItemsActive ? 'active' : ''}`}
              onClick={handleCustomItemsClick}
            >
              <span>{userSettings?.custom_buylist_button_label || 'Other Items We Buy'}</span>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
